var map = {
	"./arrows-alt-solid.svg": "./resources/images/icons/arrows-alt-solid.svg",
	"./ban.svg": "./resources/images/icons/ban.svg",
	"./check.svg": "./resources/images/icons/check.svg",
	"./close.svg": "./resources/images/icons/close.svg",
	"./delete.svg": "./resources/images/icons/delete.svg",
	"./document.svg": "./resources/images/icons/document.svg",
	"./download.svg": "./resources/images/icons/download.svg",
	"./edit-regular.svg": "./resources/images/icons/edit-regular.svg",
	"./eye-solid.svg": "./resources/images/icons/eye-solid.svg",
	"./fa-spinner.svg": "./resources/images/icons/fa-spinner.svg",
	"./heart.svg": "./resources/images/icons/heart.svg",
	"./minus.svg": "./resources/images/icons/minus.svg",
	"./plus.svg": "./resources/images/icons/plus.svg",
	"./save.svg": "./resources/images/icons/save.svg",
	"./star.svg": "./resources/images/icons/star.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/images/icons sync recursive ^\\.\\/.*\\.svg$";